import React, { ReactElement } from 'react'
import { useFindLocaleText } from '../../../text-localisation'
import { IconDeliveryTruck, IconFlower, IconCardOpen } from './assets'

type SellingPoint = {
  icon: ReactElement
  title: string
  description: string
}

export function useSellingPoints(): SellingPoint[] {
  const localiseText = useFindLocaleText()
  return [
    {
      icon: <IconFlower aria-hidden width="100%" />,
      title: localiseText('usp.freshness_guarantee.title'),
      description: localiseText('usp.freshness_guarantee.description'),
    },
    {
      icon: <IconCardOpen aria-hidden width="100%" />,
      title: localiseText('usp.perfect_gift_companion.title'),
      description: localiseText('usp.perfect_gift_companion.description'),
    },
    {
      icon: <IconDeliveryTruck aria-hidden width="100%" />,
      title: localiseText('usp.next_day_delivery.title'),
      description: localiseText('usp.next_day_delivery.description'),
    },
  ]
}
